// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2mMi3","modalContent":"Modal_modalContent__uCZ7D","modalHeader":"Modal_modalHeader__2HFoJ","err":"Modal_err__fjDgf","modalFooter":"Modal_modalFooter__3_uh9"};